<template>
   <div class="input-group mr-4" style="width: clamp(6rem, 100%, 24rem)">
        <div class="input-group-prepend">
            <span class="input-group-text"><b-icon icon="search" /></span>
        </div>
        <input :id="id" :value="value" @input="search($event.target.value)" type="text" class="form-control" :placeholder="placeholder" />
    </div>
</template>

<script>
import id from "src/modules/uuid.js"

export default {
    props: {
        id: new id(),
        value: String,
        debounce: {
            type: Boolean,
            default: true,
        },
        debounceTime: { // In milliseconds
            type: Number,
            default: 200
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            debounceTimerId: undefined,
        }
    },
    methods: {
        search(value) {
            if (!this.debounce) this.$emit('input', value)

            if (this.debounceTimerId) clearTimeout(this.debounceTimerId)

            this.debounceTimerId = setTimeout(() => {
                this.$emit('input', value)
                this.debounceTimerId = null
            }, this.debounceTime)
        }
    }
}
</script>